import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { BASE_LINK, MY_RESERVE_LINK, ROOM_FORM_LINK } from "../actions/types";
class Nav extends Component {
	render() {
		return (
			<div className="nav">
				<NavLink exact to={BASE_LINK} className="nav-item" activeClassName="nav-item-active">
					<div className="nav-img index-img"></div>
					<div>首页</div>
				</NavLink>
				<NavLink exact to={ROOM_FORM_LINK} className="nav-item" activeClassName="nav-item-active">
					<div className="nav-img reserve-img"></div>
					<div>预约</div>
				</NavLink>
				<NavLink to={`${MY_RESERVE_LINK}`} className="nav-item" activeClassName="nav-item-active">
					<div className="nav-img my-img"></div>
					<div>我的</div>
				</NavLink>
			</div>
		);
	}
}
export default Nav;
